import { __assign, __extends, __rest, __spreadArrays } from "tslib";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { SortableContainer } from "react-sortable-hoc";
import { ButtonWithIcon } from "../ButtonWithIcon";
import { ISelectedNode } from "../../models/node";
import { ITranslations } from "../../models/translations";
import { SortButton } from "./SortButton";
import { SortableItem } from "./SortableItem";
var SortableList = (function (_super) {
    __extends(SortableList, _super);
    function SortableList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SortableList.prototype.render = function () {
        var _a = this.props, options = _a.options, selectedOptions = _a.selectedOptions, optionType = _a.optionType, buttonTitle = _a.buttonTitle, showButton = _a.showButton, listTitle = _a.listTitle, isOptional = _a.isOptional, onOptionAdded = _a.onOptionAdded, t = _a.t, otherProps = __rest(_a, ["options", "selectedOptions", "optionType", "buttonTitle", "showButton", "listTitle", "isOptional", "onOptionAdded", "t"]);
        return (React.createElement("div", null,
            React.createElement("div", { className: "rb-title-dark rb-title-extra-small" },
                listTitle,
                " ",
                isOptional && React.createElement("span", null,
                    "- ",
                    t.optionalLabel)),
            React.createElement("div", { className: "rb-report-options" },
                selectedOptions.map(function (selectedOption, index) {
                    var disabled = !!(selectedOption && selectedOption.value);
                    var filteredOptions = options;
                    if (!disabled) {
                        var selectedValues_1 = selectedOptions.map(function (selected) { return selected.value; });
                        filteredOptions = options.filter(function (option) { return selectedValues_1.indexOf(option.name) === -1; });
                    }
                    return (React.createElement(SortableItem, __assign({ key: index, index: index, disabled: !disabled, options: __spreadArrays(filteredOptions), optionType: optionType, selectedOption: selectedOption, selectDisabled: disabled, sortButton: React.createElement(SortButton, { sorting: selectedOption.sorting }) }, otherProps)));
                }),
                showButton && (React.createElement("div", { className: "rb-btn-container rb-fill-parent" },
                    React.createElement(ButtonWithIcon, { title: buttonTitle, styleClasses: "rb-btn-small rb-btn-red rb-fill-parent", icon: faPlusCircle, onClick: function () { return onOptionAdded(optionType); } }))))));
    };
    return SortableList;
}(React.PureComponent));
var withSortableContainer = SortableContainer(SortableList);
export { withSortableContainer as SortableList };
